<template>
  <div>
    <el-dialog
      :id="$options.name"
      :before-close="noDialog"
      :fullscreen="dialogFullscreen"
      :visible.sync="dialog"
      title="配置充电时间"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="wrapper_right">
        <div>
          <!-- <div class="right_title">配置充电时间</div>
          <el-form :model="form">
            <el-form-item label="时间类型" prop="resource">
              <el-radio-group v-model="form.select">
                <el-radio label="1">按小时</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form> -->
          <div class="time-conf">
            <div v-for="(item, index) in list" :key="index" class="select">
              <div :class="{ checked: checked(item) }" @click="change(item)">
                {{ item.label }}
              </div>
            </div>
          </div>
          <div v-if="form.select === '1'" class="title">
            (备注：数字为对应的充电时间，单位小时，最长10小时，最多选择6个)
          </div>
        </div>
      </div>

      <div slot="footer">
        <el-button @click="noDialog">取消</el-button>
        <el-button type="primary" @click="addPost">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import dialogMixin from "@/mixin/dialogMixin";
import { Message } from "element-ui";

import maintenanceManEditChargeTimeConf from "@/maintain/api/device/charging-time-conf-controler/maintenanceManEditChargeTimeConf";
import maintenanceManGetChargeTimeConf from "@/maintain/api/device/charging-time-conf-controler/maintenanceManGetChargeTimeConf";
import resDispose from "@/mixin/resDisposeMixin";

export default {
  name: "configChargeTimeDialog",
  mixins: [dialogMixin, resDispose],
  props: {
    dialog: Boolean,
    configChargeTimeId: Number,
  },
  data() {
    return {
      rules: {},
      form: {
        select: "1",
      },
      list: [],
      records: [
        {
          chargeNum: 0,
        },
        {
          chargeNum: 2,
        },
        {
          chargeNum: 4,
        },
        {
          chargeNum: 6,
        },
        {
          chargeNum: 8,
        },
        {
          chargeNum: 10,
        },
      ],
    };
  },
  computed: {
    checked() {
      return (val) => {
        return this.records.some((item) => {
          if (val.chargeNum === item.chargeNum) {
            return true;
          }
        });
      };
    },
  },
  watch: {
    configChargeTimeId: {
      handler(newV) {
        if (newV) {
          this.fetchData();
        }
      },
      deep: true,
      immediate: true,
    },
    "form.select": {
      handler(newValue) {
        console.log(newValue);
        const list = [];
        for (let i = 0; i <= 10; i++) {
          list.push({
            chargeNum: i,
            label: i == 0 ? "充满自停" : i,
          });
        }
        if (newValue === "1") {
          this.list = list;
        } else if (newValue === "2") {
          list.shift();
          this.list = list;
        }
      },
      immediate: true,
    },
  },
  methods: {
    fetchData() {
      maintenanceManGetChargeTimeConf({
        groupId: this.configChargeTimeId,
      }).then((res) => {
        // this.form.select = String(res.data.timeUnit);
        this.form.select = "1";
        if (res.data && res.data.length !== 0) {
          this.records = res.data;
        }
      });
    },
    change(val) {
      let len = this.records.length;
      let judge = this.records.some((item) => {
        if (val.chargeNum === item.chargeNum) {
          return true;
        }
      });
      if (len === 6) {
        if (judge) {
          this.listHas(val);
        }
      } else if (len < 6) {
        if (judge) {
          this.listHas(val);
        } else {
          this.records.push({
            chargeNum: val.chargeNum,
          });
        }
      }
    },
    listHas(val) {
      let index;
      for (let i = 0; i < this.records.length; i++) {
        if (val.chargeNum === this.records[i].chargeNum) {
          index = i;
          break;
        }
      }
      this.records.splice(index, 1);
    },
    addPost() {
      let dto = [];
      for (let i = 0; i < this.records.length; i++) {
        if (this.form.select === "2") {
          if (this.records[i].chargeNum !== 0) {
            dto.push(this.records[i]);
          }
        } else {
          dto.push(this.records[i]);
        }
      }
      let agentEditChargingTimeDTO = {
        chargeTimeConfDTOS: dto,
        id: this.configChargeTimeId,
        chargeTimeUnit: this.form.select,
      };
      maintenanceManEditChargeTimeConf(agentEditChargingTimeDTO)
        .then((res) => {
          if (res.code == 1) {
            this.$emit("update:dialog", false);
            Message.success("保存成功~");
          } else {
            Message.error(res.msg);
          }
        })
        .finally(() => {
          // this.loadDialog.close();
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "src/styles/my";
@include mobile {
  div.wrapper {
    display: block;
    .wrapper_right {
      .right_title {
        border-top: 1px dashed #bbb;
        margin-top: 40px;
        padding-top: 20px;
        text-align: center;
      }
    }
    .btn_box {
      margin-top: 10px;
      text-align: right;
    }
  }

  div.select {
    width: 50% !important;
    box-sizing: border-box;
    margin: 10px 0 !important;
    padding: 14px !important;
  }

  div.title {
    margin: 40px 0 30px;
    font-size: 16px;
    text-align: left;
    line-height: 25px;
  }

  .qrcode_wrapper {
    flex-direction: column;
    .qrcode_box {
      margin-bottom: 40px;
      margin-right: 0;
    }
  }
}

.wrapper_right {
  flex: 2;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .right_title {
    font-weight: bold;
    font-size: 15px;
    color: #409eff;
    margin-bottom: 15px;
  }
}

.time-conf {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
.select {
  margin-left: 20px;
  text-align: center;
  height: 80px;
  width: 80px;
  line-height: 80px;
  margin-top: 20px;

  & > div {
    color: #b3b3b3;
    border: 2px solid #b3b3b3;
  }
}

.select + .select {
  margin-left: 20px;
}

.checked {
  color: #ff6600 !important;
  border: 2px solid #ff6600 !important;
}

.title {
  text-align: center;
  font-size: 18px;
  margin-top: 20px;
  color: #606266;
}
</style>
